import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { API_BASE } from '../config';
import './EventsSection.css';

const EventsSection = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/events?status=upcoming`)
      .then(res => res.json())
      .then(data => setUpcomingEvents(data))
      .catch(() => {});

    fetch(`${API_BASE}/events?status=past`)
      .then(res => res.json())
      .then(data => setPastEvents(data))
      .catch(() => {});
  }, []);

  const events = activeTab === 'upcoming' ? upcomingEvents : pastEvents;

  if (upcomingEvents.length === 0 && pastEvents.length === 0) return null;

  return (
    <section className="events-section">
      <div className="events-container">
        <div className="events-header">
          <div className="events-header-left">
            <span className="events-subtitle">Etkinlikler</span>
            <h2 className="events-title">Neler Oluyor?</h2>
          </div>
          <div className="events-tabs">
            <button
              className={`events-tab ${activeTab === 'upcoming' ? 'active' : ''}`}
              onClick={() => setActiveTab('upcoming')}
            >
              Gelecek Etkinlikler
            </button>
            <button
              className={`events-tab ${activeTab === 'past' ? 'active' : ''}`}
              onClick={() => setActiveTab('past')}
            >
              Geçmiş Etkinlikler
            </button>
          </div>
        </div>

        <div className="events-grid">
          {events.map((event) => (
            <Link to={`/${event.slug}`} className="event-card" key={event._id}>
              <div className="event-card-image">
                <img src={event.image} alt={event.title} />
                <div className="event-card-overlay"></div>
                <span className={`event-tag ${event.status === 'past' ? 'event-tag--past' : ''}`}>
                  {event.status === 'upcoming' ? 'Yaklaşan' : 'Tamamlandı'}
                </span>
              </div>
              <div className="event-card-body">
                <h3 className="event-card-title">{event.title}</h3>
                <p className="event-card-desc">{event.description}</p>
                <div className="event-card-meta">
                  <span><FaCalendarAlt /> {event.date}</span>
                  {event.time && <span><FaClock /> {event.time}</span>}
                  {event.location && <span><FaMapMarkerAlt /> {event.location}</span>}
                </div>
                {event.status === 'upcoming' && (
                  <span className="event-card-btn">
                    Detaylar <FaArrowRight />
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
